




















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { hasPermission } from '@/utils/utils';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: { ...mapGetters(['userInfo']) }
})
class KP extends Vue {
  userInfo: any;
  collapsed: boolean = true;
  basePath: any[] = [];
  menuList: any[] = [
    {
      name: 'seed部门公客池',
      path: '/kp/seed',
      iconType: 'bar-chart',
      show: false,
      permissionPath: '/kp/seed'
    },
    {
      name: 'BP投递',
      path: '/bp/seed',
      iconType: 'unordered-list',
      show: false,
      permissionPath: '/bp/seed'
    }
  ];

  @Watch('$route.path', { immediate: true })
  routeChange(value) {
    if (value === '/kp') {
      this.initMenu();
      this.initRoute();
    } else {
      this.setMenuOpenKey();
    }
  }

  created() {
    this.initMenu();
    this.initRoute();
    this.setMenuOpenKey();
  }

  beforeDestroy() {}

  handleClick(e) {
    this.$router.push(e.key);
  }

  initMenu() {
    const { permissions: queue } = this.userInfo || {};
    this.menuList.forEach(_ => (_.show = hasPermission(queue, _.permissionPath)));
  }

  initRoute() {
    let defaultMenu = this.menuList.find(_ => _.show);
    let path = this.$route.path;
    if (defaultMenu && /^\/kp\/?$/.test(path)) {
      this.$router.push(defaultMenu.path);
      path = defaultMenu.path;
    }
    this.basePath[0] = path;
    console.log('init route', this.basePath);
  }

  setMenuOpenKey() {
    let current = this.menuList.find(v => this.$route.path.match(v.path));
    if (current) {
      this.basePath = [current.path];
    }
  }
}

export default KP;
